// src/services/stripeService.js

// Smart routing: Uses localhost during development, and the live domain in production!
const API_BASE_URL = window.location.hostname === 'localhost'
    ? 'http://localhost:5001'
    : 'https://api.bundlemadnesshair.com';

// currency: 'GBP' or 'USD' (from useCurrency()). The server decides the real
// prices and which shipping country is allowed, based on this currency.
export const createCheckoutSession = async (cartItems, customerEmail, userId, appliedCode, currency = 'GBP') => {
    try {
        const response = await fetch(`${API_BASE_URL}/create-checkout-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: cartItems,
                customerEmail: customerEmail,
                userId: userId,
                appliedCode: appliedCode,
                currency: currency
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to initialize checkout');
        }

        const session = await response.json();

        if (session.url) {
            window.location.href = session.url;
        } else {
            throw new Error('No checkout URL returned from server.');
        }

    } catch (error) {
        console.error('Checkout error:', error);
        throw error;
    }
};